import moment from 'moment';

export const normalizeDay = (d: any) => {
  // Return a moment representing the SAME LOCAL CALENDAR DAY (no UTC shift for YYYY-MM-DD)
  if (d == null) {
    return null;
  }
  if (typeof d === 'number') {
    return moment(d);
  }
  if (d instanceof Date) {
    return moment(d);
  }
  if (typeof d === 'string') {
    const s = d.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      return moment(s, 'YYYY-MM-DD');
    }
    return moment(s); // ISO / with time/offset
  }
  return moment(d);
};
